import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownCommsPlanTemplates = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, organisation_id } ) =>
{
    if ( organisation_id === undefined || organisation_id === null )
    {
        throw new Error ("Invalid organisation_id Passed to DropdownCommsPlanTemplates") ;
    }

    const url = '/organisation/' + organisation_id + '/templates' ;

    const fields = { url: url, keyFieldName: 'cp_template_id', labelFieldName: 'cp_plan_title' }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownCommsPlanTemplates;
